<template>
    <div class="wrapper" v-if="render">
        <div class="mainBody">
            <h2>Töölaud</h2>
            <Button class="logoutBtn" label="Logi välja" outlined severity="info" @click="logout" />
            <div class="panelButtons">
                <panelButton :shopData="shopData" :gridButtons="gridButtons" />
            </div>
            <div class="divider"></div>
            <div class="flexContainer">
                <div class="notifications">
                    <h2>Mis teoksil..</h2>
                    <singleNotification :notificationList="notificationList" />
                    <h3 v-if="notificationList.length == 0" style="font-size: 40px; color: rgb(210,210,210)">Teavitused puuduvad</h3>
                </div>
                <div class="stats">
                    <div class="numbers">
                        <!-- <div class="statContainer">
                            <div class="containerHeader" style="display: flex;">
                                <i class="pi pi-users"></i>
                                <div style="margin-bottom: 20px">
                                    <p class="statTitle">Lehe külastused</p>
                                    <h2>15 487</h2>
                                </div>
                            </div>
                            <img  
                                class="illustrationImg"
                                :src="require(`../assets/users.svg`)"
                            />
                            <div class="visitingNumbers">
                                <div class="smallTitles">
                                    <p><i class="pi pi-info-circle"></i></p>
                                    <p>Päritolu</p>
                                    <p>Vaatamiste arv</p>
                                </div>
                                <div class="singleLine">
                                    <p>
                                        <img class="faviconImg" height="24" width="24" :src='`https://www.google.com/favicon.ico`'/>
                                    </p>
                                    <p>Google otsing</p>
                                    <p>857</p>
                                </div>
                                <div class="singleLine">
                                    <p><img class="faviconImg" height="24" width="24" :src='`https://www.facebook.com/favicon.ico`'/></p>
                                    <p>Facebook</p>
                                    <p>244</p>
                                </div>
                                <div class="singleLine">
                                    <p><img class="faviconImg" height="24" width="24" :src='`https://www.delfi.ee/favicon.ico`'/></p>
                                    <p>Delfi reklaam</p>
                                    <p>121</p>
                                </div>
                                <div class="singleLine">
                                    <p><img class="faviconImg" height="24" width="24" :src='`https://www.ohtuleht.ee/favicon.ico`'/></p>
                                    <p>Õhtulehe reklaam</p>
                                    <p>98</p>
                                </div>
                                <div class="singleLine">
                                    <p><img class="faviconImg" height="24" width="24" :src='`https://www.neti.ee/favicon.ico`'/></p>
                                    <p>neti.ee</p>
                                    <p>52</p>
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="statContainer">
                            <i class="pi pi-euro" style="color: #22c55e"></i>
                            <div style="margin-bottom: 60px">
                                <p class="statTitle" style="color: #22c55e">Teenistus</p>
                                <h2 style="color: #22c55e">8 700</h2>
                            </div>
                            <img  
                                :src="require(`../assets/rate.svg`)"
                            />
                        </div>

                        <div class="statContainer">
                            <i class="pi pi-shopping-cart" style="color: #F97316"></i>
                            <div style="margin-bottom: 60px">
                                <p class="statTitle" style="color: #F97316">Tellimusi</p>
                                <h2 style="color: #F97316">143</h2>
                            </div>
                            <img  
                                :src="require(`../assets/locations.svg`)"
                            />
                        </div> -->
                    </div>
                </div>
                <div class="overview">
                    <h2>Poe ülevaade</h2>
                    <div class="data">
                        <p v-if="shopData.isOpen"> <b class="openSign">POOD<i class="pi pi-sparkles" style="margin-right: 8px; margin-left: 8px;"></i>AVATUD</b></p>
                        <p v-if="!shopData.isOpen"> <b class="closedSign">POOD<i class="pi pi-lock" style="margin-right: 8px; margin-left: 8px;"></i>SULETUD</b></p>
                    </div>
                    <div class="messages" style="width: 100%; margin-left: auto;" v-if="shopDealsMetadata">
                        <Message severity="success" icon="pi pi-verified" style="height: 50px;">{{ shopDealsMetadata.isNotAcceptedCount }} uut tellimust</Message>
                        <Message severity="info" icon="pi pi-paperclip" style="height: 50px;">{{ shopDealsMetadata.isNotShippedCount }} täitmata tellimust</Message>
                        <Message severity="error" icon="pi pi-exclamation-triangle" style="height: 50px;">{{ stockQuantities.zeroStockCount }} toodet otsas</Message>
                        <Message severity="warn" icon="pi pi-exclamation-circle" style="height: 50px;">{{ stockQuantities.lowStockCount }} toodet otsakorral</Message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import logoutFetch from '../apiFetches(old)/logoutFetch'

import panelButton from '@kristjan87/storium-workboard-library/src/components/universal/buttons/panelBtn/panelBtn.vue';
import singleNotification from '@kristjan87/storium-workboard-library/src/components/universal/notifications/singleNotification.vue';
import gridButtons from '../components/gridButtons'
import Message from 'primevue/message';
import Button from 'primevue/button';
import core from '../api/index'
export default {
    name: 'workboardView',
    components: {
        Button,
        panelButton,
        singleNotification,
        Message,
    },
    props: {
        shopData: null,
        shippingProfile: null,
        shopProducts: null,
        shopDealsMetadata: null,
    },
    watch: {
        $route(to, from) {
            if (from.path === '/toolaud/pood' || from.path === '/toolaud/tooted' || from.path === '/toolaud/tellimused') {
                this.$emit('fetchData')
            }
        },
        shopData: {
            handler(newVal) {
                if (newVal) {
                    this.render = true
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        },
        shopDealsMetadata: {
            handler(newVal) {
                if (newVal) {
                    this.setOverviewData()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        }
    },
    data() {
        return {
            render: false,
            gridButtons: gridButtons(),

            notificationList: []
,        };
    },
    computed: {
        stockQuantities() {
            // Count how many have exactly 0 stock
            const zeroStockCount = this.shopProducts.filter(product => {
                return product.stockStatus && product.stockStatus.total === 0
            }).length

            // Count how many are “low stock” but NOT zero
            const lowStockCount = this.shopProducts.filter(product => {
                // Must be flagged as low stock
                // Must NOT have total === 0
                return product.isLowStockWarning
                    && product.stockStatus
                    && product.stockStatus.total !== 0
            }).length

            return { zeroStockCount, lowStockCount }
        }
    },
    methods: {

        getUserNots() {
            this.notificationList = []
            core.notificationApi.getUserNotifications()
            .then((res) => {
                if(res.data.notifications == null) {
                    this.notificationList = []
                } else {
                    for(const element of res.data.notifications) {
                        this.notificationList.push({
                            "idNotification": element.idNotification,
                            "subject": element.subject,
                            "text": element.text,
                            "timestamp": element.timestamp,
                            "isForwarded": element.isForwarded
                        })
                    }
                    this.notificationList.sort()
                    this.notificationList = this.notificationList.splice(0, 5)
                }
            })
        },

        logout() {
            logoutFetch()
            .then(() => {
                this.$router.push('/login')
            })
        },

        setOverviewData() {

        }
    },
    created() {
        this.getUserNots()
        this.$emit('fetchData')
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>

<style>
.overview .p-message {
    background: white;
    margin-bottom: 13px;
    overflow: hidden;
}
.overview .p-message-text {
    text-align: end;
    width: 100%;
}
.overview .p-message-content {
  background: white;
}
</style>
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
}
.mainBody {
    position: relative;
    width: 1420px;
    margin: 0 auto;
    padding-top: 75px;
    padding-bottom: 50px;
}
.mainBody h2 {
    margin: 0;
    font-size: 32px;
}
.logoutBtn {
    position: absolute;
    right: 0;
    top: 40px;
}
.panelButtons {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.notifications {
    width: 450px;
}
.flexContainer {
    margin-top: 25px;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.notifications h2 {
    margin: 0;
    margin-bottom: 25px;
    color: silver;
}
.overview {
    width: 450px;
    text-align: end;
}
.overview h2 {
    margin: 0;
    margin-bottom: 25px;
    color: silver;
    text-align: end;
}
.data {
    margin-top: 40px;
    margin-bottom: 40px;
}
.data p {
    font-size: 18px;
}
.openSign {
    color: rgb(37, 221, 129);
    border-top: 1px solid rgb(86, 219, 175, 0.644);
    background: white;
    border-radius: 10px;
    padding: 15px 145px 15px 145px;
    white-space:nowrap;
    box-shadow: 0 3px 4px rgba(86, 219, 175, 0.644),0 24px 36px #0000000a;
}
.closedSign {
    color: rgb(221, 65, 37);
    border: 1px solid rgb(221, 65, 37, 0.644);
    background: white;
    border-radius: 10px;
    padding: 15px 145px 15px 145px;
    white-space:nowrap;
    box-shadow: 0 3px 4px rgba(221, 65, 37, 0.644),0 24px 36px #0000000a;
}
.divider {
    margin-top: 50px;
    width: 100%;
    height: 1px;
    border-radius: 10px;
    background: rgb(218, 231, 236);
}
.stats {
    margin-top: 65px;
    width: 450px;
}
.numbers {
    justify-content: space-between;
}
.statContainer {
    position: relative;
    box-shadow: 0 3px 4px #0000001a,0 24px 36px #0000000a;
    border-radius: 14px;
    background: white;
    width: 450px;
    padding-top: 15px;
    overflow: hidden;
    margin-bottom: 20px;
}
.statContainer:last-child {
    margin-bottom: 0;
    padding-top: 16px;
}
.containerHeader i {
    margin-top: -4px;
    margin-left: 30px;
    margin-right: 15px;
    font-size: 62px;
    color: #3B82F6;
}
.statTitle {
    margin: 0;
    color: #3B82F6;
    font-size: 14px;
    text-transform: uppercase;
    font-family: 'DM sans', sans-serif;
    font-weight: 500;
}
.statContainer h2 {
    margin: 0;
    color: #3B82F6;
    font-family: 'DM sans', sans-serif;
    font-weight: 500;
}
.illustrationImg {
    position: absolute;
    top: 0;
    rotate: 180deg;
    transform: scaleX(-1);
    width: 100%;
    opacity: .2;
}
.visitingNumbers {
    border-top: 1px solid rgb(217, 230, 241);
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 5px;
}
.smallTitles {
    display: flex;
    border-bottom: 1px solid rgb(217, 230, 241);
    margin-bottom: 14px;
}
.smallTitles p:first-child {
    width: 12%;
    text-align: start;
}
.smallTitles p:last-child {
    text-align: end;
}
.smallTitles p {
    width: 44%;
    text-align: center;
    font-weight: bold;
    color: #3B82F6;
    margin: 0;
    margin-top: 14px;
    margin-bottom: 10px;
}
.smallTitles i {
    font-size: 24px;
}
.singleLine {
    display: flex;
    margin-top: 10px;
    margin-bottom: 15px;
}
.singleLine p:first-child {
    width: 12%;
    text-align: start;
}
.singleLine p:last-child {
    text-align: end;
}
.singleLine p {
    width: 44%;
    text-align: center;
    margin: 0;
    color: rgb(88, 110, 121);
}
@media (max-width: 1470px) {
    .mainBody {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
    }
    .flexContainer {
        flex-wrap: wrap;
        justify-content:start;
        column-gap: 15px;
        row-gap: 15px;
    }
    .panelButtons {
        justify-content:start;
        column-gap: 15px;
        row-gap: 15px;
    }
}
@media (max-width: 1024px) {
    .mainBody {
        padding-top: 50px;
        padding-bottom: 25px;
    }
    .logoutBtn {
        top: 20px;
        right: 25px;
    }
}

@media (max-width: 768px) {
    .statContainer {
        width: 100%;
    }
    .openSign,
    .closedSign {
        padding: 10px;
        font-size: 14px;
    }
}

@media (max-width: 500px) {
    .mainBody h2 {
    }
    .mainBody {
        padding-top: 100px;
        padding-bottom: 25px;
    }
    .overview {
        width: 100%;
        text-align: end;
    }
    .logoutBtn {
        font-size: 14px;
    }
    .statContainer i {
        font-size: 32px;
    }
    .statContainer p,
    .statContainer h2 {
        font-size: 14px;
    }
    .openSign,
    .closedSign {
        padding: 10px 20px;
        font-size: 14px;
    }
    .data p {
        font-size: 16px;
    }
    .stats {
        display: none;
    }
}
</style>